import { ButtonData } from "./components/wordpress/types_and_parser/extra_types.mod"
import { TokenMemo } from "./components/public_site/custom_pages/types.mod"

export type Option<T> = { kind: 'none', } | { kind: 'some', value: T }

export function Option<T>(value: T): Option<T> {
  if (!value) return { kind: 'none' }

  return {
    kind: 'some',
    value: value,
  }
}

export function toRelativeUrl(url: string): string {
  return url.replace(`${window.location.protocol}//${window.location.host}`, '')
}

export function urlIsExternal(url: string): boolean {
  return url.startsWith('http') && !url.startsWith(`${window.location.protocol}://${window.location.host}`)
}

export function createButtonData(text: string, url: string): ButtonData {
  return { text: text, url: url}  
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export type LoadState<T> = {
  kind: 'loading'
} | {
  kind: 'error'
  errors: {
    [key: string]: string
  }
} | {
  kind: 'loaded'
  data: Option<T>
}


export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url;
}

export function upperCaseFirst(text: string): string {
  return text ? text.substring(0, 1).toUpperCase() + text.substring(1) : ''
}

const escapeChars = { lt: '<', gt: '>', quot: '"', apos: "'", amp: '&' };

export function unescapeHTML(str) {//modified from underscore.string and string.js
    return str.replace(/\&([^;]+);/g, function(entity, entityCode) {
        var match;

        if ( entityCode in escapeChars) {
            return escapeChars[entityCode];
        } else if ( match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
            return String.fromCharCode(parseInt(match[1], 16));
        } else if ( match = entityCode.match(/^#(\d+)$/)) {
            return String.fromCharCode(~~match[1]);
        } else {
            return entity;
        }
    });
}

export function safeGet(tokenMemo: TokenMemo, key1: string, key2: string) {
  if(!tokenMemo.has(key1))
    return ''
  if(!tokenMemo.get(key1).has(key2))
    return ''
  return tokenMemo.get(key1).get(key2)
}